import type { CorrectableTermRange, WordToken } from '@littlebird/sdk';

export {
  getCorrectableTermRanges,
  tokenizeWords,
  type CorrectableTermRange,
  type WordToken,
} from '@littlebird/sdk';

export function getVisibleWordCount(
  words: readonly WordToken[],
  revealCursor: number,
  previouslyVisible: number
): number {
  let revealed = 0;
  while (revealed < words.length && words[revealed].end <= revealCursor) {
    revealed += 1;
  }
  return Math.max(revealed, Math.min(previouslyVisible, words.length));
}

export function findCorrectableTermRange(
  ranges: CorrectableTermRange[],
  offset: number
): number {
  let low = 0;
  let high = ranges.length;

  while (low < high) {
    const middle = Math.floor((low + high) / 2);

    if (ranges[middle].tokenEnd < offset) low = middle + 1;
    else high = middle;
  }

  const range = ranges[low];

  return range && offset >= range.tokenStart && offset <= range.tokenEnd
    ? low
    : -1;
}

export interface TranscriptWordSelection {
  term: string;
  // Keep the anchor when a virtualized transcript row unmounts
  rect: DOMRect;
  focusTarget?: HTMLElement;
}
